import React, {Component} from 'react';
import {Col, ControlLabel, FormControl, FormGroup} from 'react-bootstrap';
import {Async} from "react-select";

export default class TypeheadField extends Component {

	constructor(props) {
		super(props);

		this.state = {
			options: []
		}
	}

	render() {

		const {
			feedbackIcon,
			input,
			label,
			meta: {error, warning, touched},
			emptyText,
			sizes,
			clearable = false,
			loadOptions,
			onChangeHook,
			onOptionInfoHook,
			...props
		} = this.props;

		let message;
		const validationState = touched ? (error && "error") || (warning && "warning") || null : null;

		if (touched && (error || warning)) {
			message = <span className="help-block">{error || warning}</span>;
		}

		const v = input.value || (input.value === 0 ? 0 : "");
		return (
			<FormGroup controlId={input.name} validationState={validationState}>
				<Col sm={sizes && sizes[0] ? sizes[0] : 4} componentClass={ControlLabel}>{label}</Col>
				<Col sm={sizes && sizes[1] ? sizes[1] : 8}>
					<Async
						name={input.name}
						clearable={clearable}
						backspaceRemoves={false}
						deleteRemoves={false}
						simpleValue={true}
						clearValueText="Vymazat"
						clearAllText="Vymazat vše"
						noResultsText="(nic nenalezeno)"
						placeholder={emptyText || (props.disabled ? "(není)" : "...")}
						loadingPlaceholder={'...'}
						{...props} {...input}
						loadOptions={(i, c) => loadOptions(i, (e, o) => {
							this.setState({options: (e || !o || !o.options) ? [] : o.options});
							return c(e, o);
						})}
						onSelectResetsInput={false}
						onBlurResetsInput={false}
						autoBlur={true}
						onBlur={() => {
							if (v) {
								input.onBlur(v);
							}
						}}
						onChange={(value) => {
							if (onChangeHook) {
								onChangeHook(value)
							}
							if (onOptionInfoHook) {
								const filtered = value && this.state.options && this.state.options.length > 0
									? this.state.options.filter(o => o.value === value)
									: null;
								onOptionInfoHook(filtered && filtered.length >= 1 ? filtered[0].info : null);
							}
							input.onChange(value);
						}}
						value={v}
					>
					</Async>
					{feedbackIcon ? <FormControl.Feedback>{feedbackIcon}</FormControl.Feedback> : null}
					{message}
				</Col>
			</FormGroup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/form/TypeheadField.js